module.exports = __webpack_public_path__ + "static/img/teaser5.8acf709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser5.jpg
// module id = WLo1
// module chunks = 0